import { AbstractQuery } from 'src/models/query';

export class MemoQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_IdoScheduledActivity_GetTheDetailsForTheIdoScheduledActivityQuery';
	sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}

export class PersonalMemoQuery extends AbstractQuery {
	name = 'IFS_DesktopModule_Memo_Query_Queries_GetThePersonalMemoForTheUserQuery';
	sort = [];

	constructor() {
		super();
		this.cacheable = false;
		this.subscribeForUpdates = false;
	}
}
